import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'template-save-modal-app',
      templateUrl: './a-template-save-modal.component.html',
    })

export class ATemplateSaveModalComponent {
  @Input() template_name;
  @Input() m_event_task_type_id;

  save_command:number = 1;

  constructor(
    public activeModal: NgbActiveModal,
  ) {}

  ret:any={
    status:"",
    save_command:'1',
    template_name:""
  }
  
  command_list:any=[
    {save_command:1,name:"新規",disabled:false},
    {save_command:2,name:"更新",disabled:false},
    {save_command:9,name:"削除",disabled:false},
  ];

  ngOnInit(): void {
    if (this.template_name!=""){
      this.ret.save_command = 2;
      this.ret.template_name = this.template_name;
    }else{
      this.ret.save_command = 1;
      this.command_list[1].disabled = true;
      this.command_list[2].disabled = true;
    }
    if (this.m_event_task_type_id != 0){
      this.command_list[2].disabled = true;
    }
  }



  modalCloseOK() {
    this.ret.status = 'OK';
    this.ret.save_command=this.save_command;
    this.activeModal.close(this.ret);
  }
  modalCloseCancel(){
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
  }
}




// WEBPACK FOOTER //
// ./src/app/a0106-mail/a-template-save-modal.component.ts